module.exports = __webpack_public_path__ + "img/portfolio-bg.e530afc6.png";